import { Components, Theme } from '@mui/material';

const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&:hover:not(.Mui-error):not(.Mui-disabled)': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[400],
        },
      },

      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: theme.palette.grey[400],
        },
      },
      '&.Mui-focused.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.main,
        },
      },

      '&.Mui-disabled': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[300],
        },
      },
    }),

    notchedOutline: ({ theme }) => ({
      borderColor: theme.palette.grey[300],
    }),
  },
};

export default MuiOutlinedInput;
